import type { Dispatch } from "redux";
import { openConfirmation } from "@utils/redux-utils/actions/actions";

export function showPermissionDialogsNotice(dispatch: Dispatch, t: (key: string) => string) {
  dispatch(
    openConfirmation(
      t("DevicePermissions.afterConfigSetTitle"),
      t("DevicePermissions.afterConfigSetMessage"),
      () => {},
      true,
      t("close"),
      "",
    ),
  );
}
